module.exports = __webpack_public_path__ + "button-add.svg?8a0ba873b5b2363aa19a78b36f1972ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button-add.svg
// module id = 638
// module chunks = 0